import React from 'react';

type UndoIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function UndoIcon({ onClick, className = '' }: UndoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M2.5 2.5V7.5H7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58333 12.5C5.1193 13.8533 6.07129 14.9977 7.31429 15.7796C8.55729 16.5615 10.0099 16.9438 11.4741 16.8779C12.9383 16.812 14.3533 16.3008 15.5283 15.4085C16.7033 14.5162 17.5831 13.2828 18.0567 11.8762C18.5303 10.4695 18.5748 8.95541 18.1846 7.52332C17.7944 6.09123 16.9873 4.81266 15.8721 3.85755C14.7569 2.90243 13.3859 2.31536 11.9367 2.17431C10.4875 2.03326 9.03401 2.34478 7.775 3.06667L2.5 5.83333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UndoIcon;
